import axios from 'axios';

/**
 * SLA contact-center metrics.
 * Backed by the `/sla/*` endpoints added in core-api (PR #1297 / feat/aht-metric).
 * All date inputs are epoch-ms (as stored in the global module) and are sent as
 * ISO strings under the `start` / `end` keys the backend expects.
 */

const toISO = value => new Date(value).toISOString();

const cleanArray = value => (Array.isArray(value) && value.length > 0 ? value : undefined);

const state = {};

const mutations = {};

const actions = {
  // POST /sla/contact-center/aht -> { global, calls, appointments }
  aht(context, { start, end, segments, services } = {}) {
    return axios.post('sla/contact-center/aht', {
      start: toISO(start),
      end: toISO(end),
      segments: cleanArray(segments),
      services: cleanArray(services),
    }).then(({ data }) => data);
  },

  // POST /sla/contact-center/asa -> { callsDuration, callsInRange, appointmentsDuration, appointmentsInRange }
  // Requires at least one of `gte` / `lte` (SLA threshold seconds).
  asa(context, {
    start, end, gte, lte, segments, services,
  } = {}) {
    return axios.post('sla/contact-center/asa', {
      start: toISO(start),
      end: toISO(end),
      gte,
      lte,
      segments: cleanArray(segments),
      services: cleanArray(services),
    }).then(({ data }) => data);
  },

  // POST /sla/contact-center/frt -> { calls, appointments, global }
  frt(context, { start, end, segments, services } = {}) {
    return axios.post('sla/contact-center/frt', {
      start: toISO(start),
      end: toISO(end),
      segments: cleanArray(segments),
      services: cleanArray(services),
    }).then(({ data }) => data);
  },

  // POST /sla/surveys -> { nps, ces, csat, range }
  surveys(context, { start, end, surveys } = {}) {
    return axios.post('sla/surveys', {
      surveys: cleanArray(surveys),
      start: toISO(start),
      end: toISO(end),
    }).then(({ data }) => data);
  },

  // POST /sla/queues/abandoned -> { total, percentage }
  queuesAbandoned(context, { start, end, segments } = {}) {
    return axios.post('sla/queues/abandoned', {
      start: toISO(start),
      end: toISO(end),
      segments: cleanArray(segments),
    }).then(({ data }) => data);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
